import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { ThemeProvider, Toaster, TooltipProvider } from '@eon/ui';
import { hooks } from '@eon/api-client';
import { routeTree } from './router';

const queryClient = hooks.createQueryClient();
const basepath = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '') || undefined;
const router = createRouter({ routeTree, context: { queryClient }, basepath });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={150}>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
